export const useLoading = () => {
  const activeApiActions = ref([]);

  const isLoading = computed(() => {
    return Boolean(activeApiActions.value.length);
  });

  const setActiveApiAction = (action) => {
    activeApiActions.value.push(action);
  };

  const removeActiveApiAction = (action) => {
    activeApiActions.value = activeApiActions.value.filter(
      (item) => item !== action,
    );
  };

  return {
    isLoading,
    setActiveApiAction,
    removeActiveApiAction,
  };
};
